import React, { ReactNode } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import { Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getBaseDialogStyles } from './styles';

interface BaseDialogProps {
  children: ReactNode;
  open: boolean;
  showCloseIcon: boolean;
  showCloseButton: boolean;
  onClose(): void;
  onExited?(): void;
  header?: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

interface DialogTitleProps {
  children: React.ReactNode;
  showCloseIcon: boolean;
  onClose: () => void;
}

const ClosableDialogTitle = (props: DialogTitleProps) => {
  const theme = useTheme();
  const styles = getBaseDialogStyles(theme);

  const { children, onClose, showCloseIcon, ...other } = props;
  return (
    <DialogTitle sx={styles.root} {...other}>
      <Typography variant='h6'>{children}</Typography>
      {showCloseIcon && (
        <IconButton sx={styles.closeButton} onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
  );
};

const BaseDialog = (props: BaseDialogProps) => {

  const maxWidth = props.maxWidth === undefined ? 'sm' : props.maxWidth;

  const header = (
    <ClosableDialogTitle
      showCloseIcon={props.showCloseIcon}
      onClose={props.onClose}
    >
      {props.header}
    </ClosableDialogTitle>
  );

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        maxWidth={maxWidth}
        fullWidth={true}
        slotProps={{ transition: { onExited: props.onExited } }}
      >
        {header}
        <DialogContent>{props.children}</DialogContent>
        <DialogActions>
          {props.showCloseButton && (
            <Button onClick={props.onClose} color='primary'>
              Close
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BaseDialog;
